import { createGoogleAnalyticsService } from '../../google-analytics/src';
import { createAnalyticsManager } from './analytics-manager';
import type { AnalyticsManager } from './types';

export const analytics: AnalyticsManager = createAnalyticsManager({
  providers: {
    'google-analytics': createGoogleAnalyticsService,
  },
});

export * from './events';
